import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiEye, FiEyeOff, FiAlertCircle, FiGlobe, FiMail, FiLock } = FiIcons;

const ConnectionForm = ({ onConnect, isLoading, error }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    url: '', // Mantido vazio para não exibir o domínio por padrão
    email: '',
    password: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onConnect(formData);
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-4">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} className="bg-white rounded-[3rem] shadow-2xl p-8 sm:p-12 w-full max-w-lg border border-slate-50 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-50 rounded-full -mr-16 -mt-16 opacity-50" />
        
        <div className="text-center mb-12 relative">
          <div className="bg-slate-900 w-20 h-20 rounded-[2rem] flex items-center justify-center mx-auto mb-6 shadow-2xl rotate-3">
            <SafeIcon icon={FiShield} className="text-white text-3xl" />
          </div>
          <h1 className="text-2xl font-black text-slate-900 tracking-tight uppercase">GretaBase</h1>
          <p className="text-slate-400 text-[10px] font-black uppercase tracking-[0.3em] mt-3">Infrastructure Orchestrator</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4 relative">
          <div className="space-y-1">
            <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest ml-1">Instance Endpoint</label>
            <div className="relative">
              <SafeIcon icon={FiGlobe} className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-300" />
              <input type="url" value={formData.url} onChange={(e) => setFormData({ ...formData, url: e.target.value })} className="w-full pl-14 pr-6 py-5 bg-slate-50 border-2 border-transparent focus:border-indigo-500 rounded-3xl outline-none font-bold text-xs shadow-inner transition-all" placeholder="https://db.exemplo.com" required />
            </div>
          </div>

          <div className="space-y-1">
            <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest ml-1">Superuser Email</label>
            <div className="relative">
              <SafeIcon icon={FiMail} className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-300" />
              <input type="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} className="w-full pl-14 pr-6 py-5 bg-slate-50 border-2 border-transparent focus:border-indigo-500 rounded-3xl outline-none font-bold text-xs shadow-inner transition-all" placeholder="admin@base.ai" required />
            </div>
          </div>

          <div className="space-y-1">
            <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest ml-1">Master Password</label>
            <div className="relative">
              <SafeIcon icon={FiLock} className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-300" />
              <input type={showPassword ? "text" : "password"} value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} className="w-full pl-14 pr-14 py-5 bg-slate-50 border-2 border-transparent focus:border-indigo-500 rounded-3xl outline-none font-bold text-xs shadow-inner transition-all" placeholder="••••••••" required />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-5 top-1/2 -translate-y-1/2 text-slate-300 hover:text-indigo-600 transition-colors">
                <SafeIcon icon={showPassword ? FiEyeOff : FiEye} />
              </button>
            </div>
          </div>

          {error && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="p-5 bg-red-50 border-2 border-red-100 rounded-[1.5rem] text-red-600 text-[10px] font-black uppercase flex items-center space-x-3">
              <SafeIcon icon={FiAlertCircle} className="text-base" />
              <span>{error}</span>
            </motion.div>
          )}

          <button type="submit" disabled={isLoading} className="w-full bg-slate-900 text-white py-6 rounded-[2rem] font-black text-xs uppercase tracking-[0.2em] hover:bg-black transition-all shadow-2xl shadow-slate-200 mt-6 active:scale-95">
            {isLoading ? "Sincronizando..." : "Acessar Infraestrutura"}
          </button>
        </form>
      </motion.div>
    </div>
  );
};

export default ConnectionForm;